import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { XCircle } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import SiteFooter from "@/components/SiteFooter";
import Seo from "@/components/Seo";

export default function CheckoutCancelPage() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-navy-dark flex flex-col">
      <Seo noindex title="Compra Cancelada" />
      <div className="flex-1 flex items-center justify-center p-4">
        <motion.div
          className="w-full max-w-md"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          <Card className="bg-navy border-gold/20 shadow-2xl">
            <CardContent className="pt-8 pb-8 text-center">
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ type: "spring", duration: 0.5 }}
              >
                <XCircle className="w-20 h-20 text-amber-400 mx-auto mb-4" />
              </motion.div>
              <h2 className="font-heading text-2xl text-white mb-2">{t("checkoutPage.cancelledTitle")}</h2>
              <p className="text-white/60 font-body mb-6">
                {t("checkoutPage.cancelledDesc")}
              </p>
              <div className="space-y-3">
                <Button
                  onClick={() => navigate("/")}
                  className="w-full bg-gold hover:bg-gold-dark text-white font-semibold py-5 rounded-full"
                  data-testid="try-again-btn"
                >
                  {t("checkoutPage.tryAgain")}
                </Button>
                <Button
                  variant="outline"
                  onClick={() => navigate("/")}
                  className="w-full border-white/20 text-white hover:bg-white/10 rounded-full"
                >
                  {t("checkoutPage.backHome")}
                </Button>
              </div>
            </CardContent>
          </Card>
        </motion.div>
      </div>
      <SiteFooter />
    </div>
  );
}
